export default "__VITE_ASSET__CNexIBe9__"